// Reply-box attachment preview (2026-10-07): an attachment whose dataUrl is an
// image can be opened in the image lightbox before Send. The preview shows the
// exact dataUrl Send transmits — nothing is re-fetched or re-rendered.

export function isPreviewableAttachment(attachment) {
  return typeof attachment?.dataUrl === 'string' && attachment.dataUrl.startsWith('data:image/')
}

// The lightbox's images: the previewable attachments, in list order.
export function previewImagesFor(attachments) {
  return (attachments ?? [])
    .filter(isPreviewableAttachment)
    .map((a) => ({ id: a.id, name: a.name, url: a.dataUrl }))
}

// An attachment's size as the list shows it: B, KB or MB.
export function formatAttachmentSize(bytes) {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
